import React from 'react';


interface SvgProps {
  fill: string;
}
function SvgComponent(props: SvgProps) {
  const { fill = '#001325' } = props;
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M20 5.6L18.4 4 12 10.4 5.6 4 4 5.6l6.4 6.4L4 18.4 5.6 20l6.4-6.4 6.4 6.4 1.6-1.6-6.4-6.4L20 5.6z"
        fill={fill}
        fillOpacity={0.92}
      />
    </svg>
  );
}

export default SvgComponent;
